import { faGear } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

function MetaSettingsButton(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Button name={'meta-settings-button'} prefix={<FontAwesomeIcon icon={faGear} />}>
      {t('Settings')}
    </Button>
  );
}

export default MetaSettingsButton;
